import { formatarCustoGrafico } from './helpers'

export default {
  destruirGraficosConsumo() {
    if (!window.graficosConsumoIA) {
      return
    }

    window.graficosConsumoIA.forEach(grafico => {
      try {
        grafico.destroy()
      } catch (e) {
        // ignore
      }
    })
    window.graficosConsumoIA = []
  },
  parseDataGrafico(dateStr) {
    return new Date(String(dateStr).substring(0, 10) + 'T00:00:00')
  },
  formatarLabelsGrafico(categories) {
    return (categories || []).map(dateStr => {
      const date = this.parseDataGrafico(dateStr)
      if (isNaN(date.getTime())) {
        return dateStr
      }
      return date.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' })
    })
  },
  converterSerieParaDatetime(categories, series) {
    const timestamps = (categories || []).map(dateStr => this.parseDataGrafico(dateStr).getTime())

    return (series || []).map(serie => ({
      name: serie.name,
      data: (serie.data || []).map((valor, index) => ({
        x: timestamps[index],
        y: valor,
      })),
    }))
  },
  obterConfigEixoTemporal(categories) {
    const dias = (categories || []).length
    const maxTicks = dias <= 14 ? dias : dias <= 60 ? 10 : dias <= 180 ? 8 : 6
    const rotate = dias > 21 ? -45 : 0

    const datetimeFormatter = dias > 180
      ? { year: 'yyyy', month: "MMM 'yy", day: 'dd/MM' }
      : dias > 60
        ? { year: 'yyyy', month: 'MMM/yy', day: 'dd/MM' }
        : { year: 'yyyy', month: 'dd/MM', day: 'dd/MM' }

    return {
      type: 'datetime',
      tickAmount: maxTicks,
      labels: {
        rotate,
        hideOverlappingLabels: true,
        datetimeFormatter,
      },
    }
  },
  formatarTooltipData(value) {
    const date = new Date(value)
    if (isNaN(date.getTime())) {
      return value
    }
    return date.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    })
  },
  temDadosGrafico(grafico) {
    return grafico
      && Array.isArray(grafico.categories)
      && grafico.categories.length > 0
      && Array.isArray(grafico.series)
      && grafico.series.length > 0
  },
  exibirSemDados(elementId) {
    window.$(elementId).html('<div class="text-center text-muted py-4">Nenhum dado disponível</div>')
  },
  prepareGraficoConsumoArea(elementId, grafico, yFormatter) {
    const $ = window.$

    if (typeof window.ApexCharts === 'undefined') {
      $(elementId).html('<div class="text-center text-muted py-4">Biblioteca de gráficos não carregada</div>')
      return
    }

    $(elementId).html('')

    if (!this.temDadosGrafico(grafico)) {
      this.exibirSemDados(elementId)
      return
    }

    const categories = grafico.categories || []
    const dias = categories.length

    const options = {
      chart: {
        type: 'area',
        fontFamily: 'inherit',
        height: dias > 60 ? 400 : 360,
        toolbar: { show: false },
      },
      series: this.converterSerieParaDatetime(categories, grafico.series),
      xaxis: this.obterConfigEixoTemporal(categories),
      dataLabels: { enabled: false },
      grid: {
        strokeDashArray: 1,
        padding: {
          bottom: dias > 21 ? 12 : 0,
        },
      },
      markers: { size: dias > 60 ? 0 : 4 },
      stroke: { curve: 'smooth', width: 2 },
      yaxis: {
        labels: {
          formatter: (val) => (yFormatter ? yFormatter(val) : val),
        },
      },
      tooltip: {
        x: {
          formatter: (val) => this.formatarTooltipData(val),
        },
        y: {
          formatter: (val) => (yFormatter ? yFormatter(val) : val?.toLocaleString('pt-BR')),
        },
      },
    }

    const chart = new window.ApexCharts($(elementId)[0], options)
    chart.render()
    window.graficosConsumoIA.push(chart)
  },
  prepareGraficoConsumoBar(elementId, resumo) {
    const $ = window.$

    if (typeof window.ApexCharts === 'undefined') {
      $(elementId).html('<div class="text-center text-muted py-4">Biblioteca de gráficos não carregada</div>')
      return
    }

    $(elementId).html('')

    if (!resumo || !resumo.length) {
      this.exibirSemDados(elementId)
      return
    }

    const options = {
      chart: {
        type: 'bar',
        fontFamily: 'inherit',
        height: 360,
        toolbar: { show: false },
      },
      series: [{
        name: 'Tokens',
        data: resumo.map(item => item.tokens_totais),
      }],
      xaxis: {
        categories: resumo.map(item => item.modelo),
        labels: { rotate: -45 },
      },
      dataLabels: { enabled: false },
      grid: { show: false },
    }

    const chart = new window.ApexCharts($(elementId)[0], options)
    chart.render()
    window.graficosConsumoIA.push(chart)
  },
  renderTodosGraficos() {
    this.destruirGraficosConsumo()

    this.prepareGraficoConsumoArea('#graficoConsumoTokens', this.serieTokens)
    this.prepareGraficoConsumoArea('#graficoConsumoCusto', this.serieCusto, (val) => formatarCustoGrafico(val))
    this.prepareGraficoConsumoArea('#graficoConsumoEntradaSaida', this.serieEntradaSaida)

    if (this.metricas?.resumo_por_modelo?.length) {
      this.prepareGraficoConsumoBar('#graficoConsumoPorModelo', this.metricas.resumo_por_modelo)
    }
  },
}
